import React from "react";
import { MdImage } from "react-icons/md";

const QuizQuestionImageBadge = ({ isImage }) => {
  if (!isImage) {
    return null;
  }

  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-blue-100 px-3 py-1 text-sm font-medium text-blue-700">
      <MdImage className="text-base" />
      Image Question
    </span>
  );
};

export default QuizQuestionImageBadge;